import React from 'react';
import {Grid, Button} from 'ht-styleguide';
/* Utils */
import {smoothScroll} from '../locationPage.utils';
/* Styles */
import styles from '../locationPage.module.scss';

type TextContentBlockProps = {
  title: string;
  serviceDescriptions: React.ReactNode;
};

const TextContentBlock = ({title, serviceDescriptions}: TextContentBlockProps) => (
  <Grid.Fluid classes="paddingTop-huge1 paddingBottom-small positionRelative overflowHidden">
    <Grid.Row classes={styles.blobs}>
      <Grid.Column sm={4} mdOffset={1} md={6} lgOffset={2} lg={8}>
        <h3 className="text-align-center paddingBottom-large">{title}</h3>
        {serviceDescriptions}
      </Grid.Column>
    </Grid.Row>
    <Grid.Row classes="paddingTop-medium text-align-center">
      <Grid.Column smOffset={1} sm={2} md={2} mdOffset={3} lgOffset={5} lg={2}>
        <Button huge onClick={smoothScroll} className={styles.button}>
          Get a Price
        </Button>
      </Grid.Column>
    </Grid.Row>
  </Grid.Fluid>
);

export default TextContentBlock;
